import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InputAdornment, TextField } from '@material-ui/core';
import {
  withStyles,
} from '@material-ui/core';
import { styles } from '../../style_jsx/styles';
import useShowPassword from '../use_show_password';

const PasswordField = (props) => {
  const { classes, register, name, autoComplete, error, helperText, onChange, from, maxLength, onKeyPress } = props,
        { showPassword, handleClickShowPassword, handleMouseDownPassword } = useShowPassword();
  return (
    <TextField {...
      {
        InputProps: {
          className: from === 'mfa' && classes.input_security || classes.input,
          endAdornment: (
            <InputAdornment position="end">
              <FontAwesomeIcon
                className={classes.show_hide_password}
                aria-label="toggle password visibility"
                onClick={() => handleClickShowPassword}
                onMouseDown={handleMouseDownPassword} icon={showPassword ? 'eye' : 'eye-slash'}
              />
            </InputAdornment>
          ),
        },
        inputProps: { maxLength: maxLength || '' },
        placeholder: '-',
        name,
        id: 'outlined-password-input',
        type: showPassword ? 'text' : 'password',
        size: 'small',
        onKeyPress,
        autoComplete,
        variant: 'outlined',
        inputRef: register,
        onChange,
        error,
        helperText,
      }
    } />
  );
};

export default withStyles(styles)(PasswordField);

/* <IconButton
        aria-label="toggle password visibility"
        onClick={()=>handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
    </IconButton>
>*/